import React, { useEffect, useState } from "react";
import * as theme from "../../../theme";
import { getBrokerInformation } from "../../../store/broker";
import { useSelector } from "react-redux";

const CoverTypeSelection = ({ setCoverTypes, coverinfo, allcovers }) => {
  const [selectedCoverTypes, setSelectedCoverTypes] = useState([]);
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;
  const getFilteredCoverType = async (ids) => {
    const filteredCoverTypeCode = new Set();
    await allcovers?.map((item) => {
      if (ids.includes(item.id)) {
        filteredCoverTypeCode.add(item?.covertypecode);
      }
    });
    return [...filteredCoverTypeCode];
  };
  const coverTypesId = () => {
    return allcovers?.map((item) => {
      return item.id;
    });
  };
  useEffect(async () => {
    const coverIds = coverTypesId();
    const filterCoverTypes = await getFilteredCoverType(coverIds && coverIds);
    setSelectedCoverTypes(
      coverinfo.filter((item) => filterCoverTypes.includes(item?.code))
    );
  }, [coverinfo]);

  return (
    <section
      style={{
        paddingRight: "7vmin",
        paddingLeft: "7vmin",
      }}
    >
      <select
        name="Select Coverages"
        style={{
          borderRadius: "10px",
          border: "0px",
          width: "100%",
          height: "8vmin",
          paddingLeft: "2vmin",
          paddingRight: "2vmin",
          backgroundColor: theme.COLORS.tertiary_ligthindigo,
          cursor: "pointer",
        }}
        onChange={(event) => {
          setCoverTypes(event.target.value);
        }}
      >
        {selectedCoverTypes &&
          selectedCoverTypes.map((item, i) => {
            return (
              <option
                key={i}
                value={item && item.code}
                style={{ height: "3vh" }}
              >
                {item && item.name[languagepreference]}
              </option>
            );
          })}
      </select>
    </section>
  );
};

export default CoverTypeSelection;
